// extracted by mini-css-extract-plugin
module.exports = {"actionColumn":"style__actionColumn__9Lp-N"};